export class LinkUtils {
    static addQuery(link, key, value) {
        const splited = link.split('?');
        const query = splited[1] || '';
        const queries = query.split('&');
        queries.push(`${key}=${value}`);
        return `${splited[0]}?${queries.join('&')}`;
    }
}
